export enum Column {
  TAG_NAME,
  TYPE,
  DESCRIPTION,
  DATE_CREATED,
  DATE_MODIFIED,
  TAG_ID,
  COMPANY,
}

export enum ColumnKeys {
  TAG_NAME = 'name',
  TYPE = 'type',
  DESCRIPTION = 'description',
  DATE_CREATED = 'created',
  DATE_MODIFIED = 'lastModified',
  TAG_ID = '_id',
  COMPANY = 'company.name'
}
